import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormHelperText } from "@mui/material";
import { colCenter } from "@ui/style/style";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";
export const ErrorWithIcon = ({ error }) => {
    const { t } = useTranslation();
    return (error && (_jsxs(FormHelperText, { error: true, sx: { ...colCenter, mt: 0, gap: 0.5, ml: 0 }, children: [_jsx(Icon, { icon: "eva:alert-triangle-fill", width: "16", height: "16" }), t(`${error}`)] })));
};
